// Състоянието на чиповете-филтри на „Натовареност" (статуси, маси) —
// огледало на `salesByPeriods/reportFilterState.ts`. Отделен файл, защото
// страницата внася константите, а Fast Refresh иска файл с компонент да
// изнася само компоненти.

export interface OccupancyFilterState {
  /** Стойностите на `ReservationReportStatus`. */
  statuses: string[];
  /** id-та на маси от схемата (schema_elements). */
  tableIds: string[];
}

export const EMPTY_OCCUPANCY_FILTERS: OccupancyFilterState = {
  statuses: [],
  tableIds: [],
};

export const hasActiveOccupancyFilters = (filters: OccupancyFilterState): boolean =>
  filters.statuses.length > 0 || filters.tableIds.length > 0;
